import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ChevronRight, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const KEY = "mug-feed-banner-hidden";

export function MugFeedBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(true);
  useEffect(() => { setHidden(localStorage.getItem(KEY) === "1"); }, []);
  if (!user || hidden) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="relative overflow-hidden rounded-[2rem] bg-[#0d0d0d] ring-1 ring-amber-300/40 shadow-2xl shadow-amber-500/20 fade-up" data-testid="mug-feed-banner">
      <span className="absolute -left-10 top-1/2 -translate-y-1/2 w-72 h-72 rounded-full bg-amber-400/30 blur-3xl mug-glow" aria-hidden />
      <button type="button" onClick={close} aria-label="Ausblenden" className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-white/10 text-white/80 hover:bg-white/20 flex items-center justify-center" data-testid="mug-feed-banner-close"><X className="w-4 h-4" /></button>
      <Link to="/tasse" className="relative grid grid-cols-[8.5rem_1fr] sm:grid-cols-[12rem_1fr] items-center" data-testid="mug-feed-banner-link">
        <div className="relative p-3">
          <img src="/merch/tasse-gold.jpg" alt="Dankeschön-Tasse Black & Gold" className="w-full aspect-square object-cover rounded-3xl mug-glow-img" />
          <span className="absolute top-1.5 left-1.5 px-2 py-0.5 rounded-full bg-rose-500 text-white text-[10px] font-black uppercase tracking-wider shadow-lg" data-testid="mug-feed-badge-new">Neu</span>
        </div>
        <div className="py-4 pr-10 space-y-1.5">
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-gradient-to-r from-amber-200 to-amber-500 text-[#3a2508] text-[10px] font-black uppercase tracking-[0.18em]" data-testid="mug-feed-badge-limited"><Sparkles className="w-3 h-3" /> Limitiert</span>
          <p className="font-display text-lg sm:text-2xl font-black leading-tight bg-gradient-to-r from-amber-100 via-amber-300 to-amber-500 bg-clip-text text-transparent">Unsere Dankeschön-Tasse „Black &amp; Gold“</p>
          <p className="text-xs sm:text-sm text-white/70">Als Geschenk für alle, die die Community mit mindestens 100 € unterstützen.</p>
          <span className="inline-flex items-center gap-0.5 text-xs font-bold text-amber-300">Mehr erfahren <ChevronRight className="w-3.5 h-3.5" /></span>
        </div>
      </Link>
    </div>
  );
}
